import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonicalUrl, 
  ogType = 'website',
  ogImage = '/logo.png',
  children 
}) => {
  const siteUrl = 'https://hubitable.com';
  const fullUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : null;
  
  return (
    <Helmet>
      {/* Basic metadata */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      {fullUrl && <link rel="canonical" href={fullUrl} />}
      
      {/* Open Graph tags */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={ogType} />
      {fullUrl && <meta property="og:url" content={fullUrl} />}
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Amplitude tracking script - wrapped in iife to avoid prerender errors */}
      <script>
        {`
          (function() {
            // Only execute in browser environment
            if (typeof window !== 'undefined') {
              // Load Amplitude script
              const script = document.createElement('script');
              script.src = 'https://cdn.amplitude.com/script/d610690d9504e557cb2af92afa72fa0c.js';
              script.async = true;
              script.onload = function() {
                // Initialize after script has loaded
                if (window.amplitude) {
                  window.amplitude.init('d610690d9504e557cb2af92afa72fa0c', {
                    fetchRemoteConfig: true,
                    autocapture: true
                  });
                }
              };
              document.head.appendChild(script);
            }
          })();
        `}
      </script>
      
      {/* Additional elements */}
      {children}
    </Helmet>
  );
};

export default SEO; 